import { useSelector } from 'react-redux';
import type { RootState } from 'src/logic/features/root-state.model';

export const useRootSelector = <TState>(
    selector: (state: RootState) => TState,
    equalityFn?: (left: unknown, right: unknown) => boolean
) => useSelector(selector, equalityFn);
